// extracted by mini-css-extract-plugin
module.exports = {"badge":"EventCartIcon_badge__MS8I5","noItems":"EventCartIcon_noItems__36BSa"};